/**
 * The `Content` component is responsible for rendering and managing the display of data on landing page.
 * It serves as a container for UI elements and controls related to the presentation of content.
 */

import ContentItem from "./ContentItem";
import CloseSquare from "../../../Assets/Icons/close-square.svg";
import ChevLeft from "../../../Assets/Icons/chevron-left.svg";
import ChevRight from "../../../Assets/Icons/chevron-right.svg";
import { useEffect, useState } from "react";
import ContentLastModifiedItem from "./ContentLastModifiedItem";

const Content = (props) => {
  const [page, setPage] = useState(0);
  const COUNT_LIST_VIEW = 3;
  const COUNT_GRID_VIEW = 20;
  // --------- calculation for pagination ----------
  const start = props.IsGridView
    ? page * COUNT_GRID_VIEW
    : page * COUNT_LIST_VIEW;
  const end = props.IsGridView
    ? start + COUNT_GRID_VIEW
    : start + COUNT_LIST_VIEW;
  const isLastPage = props.IsGridView
    ? props.Items.slice(start)?.length <= COUNT_GRID_VIEW
    : props.Items.slice(start)?.length <= COUNT_LIST_VIEW;
  // --------- calculation for pagination ----------

  useEffect(() => {
    setTimeout(() => {
      if (document.getElementById("home-content")) {
        document.getElementById("home-content").classList.remove("fade-in");
      }
    }, 500);
  }, [props]);

  useEffect(() => {
    if (page !== 0) {
      setPage(0);
    }
  }, [props.IsGridView]);

  const createDataArray = (IsLastModified) => {
    // The function createDataArray determines the items to display based on the IsLastModified boolean.
    // If IsLastModified is true, the function returns an array containing the first three elements.
    // If IsLastModified is false, the function returns an array starting from the fourth element,
    // as the last modified section is not separated when IsLastModified is false.
    if (IsLastModified) {
      if (props.IsGridView) {
        return [];
      } else {
        return [...props.Items].slice(0, 3);
      }
    } else {
      if (props.isMobileOrTablet) {
        return [...props.Items].slice(0, props.Items.length);
      } else if (props.IsGridView) {
        return [...props.Items].slice(start, end);
      } else {
        return [...props.Items].slice(start, end);
      }
    }
  };
  useEffect(() => {
    if (createDataArray(false)?.length === 0) {
      goToPrevPage();
    }
  }, [props.Items]);

  const goToPrevPage = () => {
    if (page !== 0) {
      setPage((prev) => prev - 1);
    }
  };
  const goToNextPage = () => {
    if (!isLastPage) {
      setPage((prev) => prev + 1);
    }
  };

  return (
    <div
      id="home-content"
      className={
        props.IsGridView
          ? "home-content home-content-grid fade-in"
          : "home-content fade-in"
      }
    >
      {props.IsGridView || props.SearchIsActive ? null : (
        <p className="row-title">Last modified</p>
      )}
      {props.SearchIsActive ? (
        <div className="search-tag">
          <p className="section-title">Search results</p>
          <section>
            <img
              alt="X"
              src={CloseSquare}
              onClick={() => props.ClearSearch()}
            />
            <p>{props.SearchKeyword}</p>
          </section>
        </div>
      ) : null}
      <div className="data-row first-row">
        {createDataArray(true).map((Item, index) => (
          <ContentLastModifiedItem
            key={index}
            LeftTabSelected={props.LeftTabSelected}
            Item={Item}
            RefreshItems={() => props.RefreshItems()}
          />
        ))}
      </div>
      {props.IsGridView ||
      props.SearchIsActive ||
      props.Items.length <= 0 ? null : (
        <p className="row-title">Others</p>
      )}
      <div className="data-row second-row">
        {createDataArray(false).map((Item, index) => (
          <ContentItem
            key={index}
            LeftTabSelected={props.LeftTabSelected}
            Item={Item}
            RefreshItems={() => props.RefreshItems()}
            IsGridView={props.IsGridView}
          />
        ))}
      </div>
      {!props.isMobileOrTablet &&
      props.Items.length > (props.IsGridView ? COUNT_GRID_VIEW : 1) ? (
        <section className="form-navigation">
          <span
            className={`navigation-item right ${
              page === 0 && "navigation-item-disabled"
            }`}
            onClick={goToPrevPage}
          >
            <img alt="" src={ChevRight} />
          </span>
          <span
            className={`navigation-item left ${
              isLastPage && "navigation-item-disabled"
            }`}
            onClick={goToNextPage}
          >
            <img alt="" src={ChevLeft} />
          </span>
        </section>
      ) : null}
    </div>
  );
};

export default Content;
